import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO = 'https://customer-assets.emergentagent.com/job_cca8665b-5293-4dd5-89e0-2957c9d7e36c/artifacts/zjtkx4ss_LOGO-MAYAPLUS.png';

export default function DataDeletionPage() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [type, setType] = useState(params.get('type') === 'data' ? 'data' : 'account');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await fetch(`${API}/privacy/deletion-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, request_type: type, message }),
      });
      if (!r.ok) throw new Error();
      setSent(true);
    } catch {
      setError("Une erreur est survenue. Vous pouvez aussi écrire à contact@mayaplus.fr");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#11041F', color: '#fff', fontFamily: 'Arial, sans-serif' }} data-testid="data-deletion-page">
      <div style={{ maxWidth: 560, margin: '0 auto', padding: '48px 24px' }}>
        <img src={LOGO} alt="Maya+" style={{ height: 40, marginBottom: 32 }} />
        <h1 style={{ fontSize: 26, marginBottom: 12 }}>Suppression de compte ou de données</h1>
        <p style={{ color: '#d6d0e0', fontSize: 14, lineHeight: 1.7, marginBottom: 28 }}>
          Conformément au RGPD, vous pouvez demander la suppression de votre compte Maya+
          (et de toutes les données associées : profils, historique, avis) ou uniquement la
          suppression de vos données en conservant votre compte. Votre demande sera traitée
          sous 30 jours et une confirmation vous sera envoyée par e-mail.
        </p>

        {sent ? (
          <div data-testid="deletion-request-success" style={{ background: '#1a0e2e', border: '1px solid rgba(233,100,26,0.4)', borderRadius: 12, padding: 24 }}>
            <p style={{ margin: 0, fontSize: 15 }}>✓ Votre demande a bien été enregistrée.</p>
            <p style={{ margin: '10px 0 0', color: '#d6d0e0', fontSize: 13 }}>
              Vous recevrez une confirmation à l'adresse indiquée une fois la suppression effectuée.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} style={{ background: '#1a0e2e', borderRadius: 12, padding: 24 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#d6d0e0', marginBottom: 6 }}>Adresse e-mail du compte</label>
            <input
              data-testid="deletion-email-input"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.fr"
              style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)', background: '#11041F', color: '#fff', fontSize: 14, marginBottom: 18 }}
            />
            <label style={{ display: 'block', fontSize: 13, color: '#d6d0e0', marginBottom: 8 }}>Type de demande</label>
            <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 10, cursor: 'pointer', fontSize: 14 }}>
              <input data-testid="deletion-type-account" type="radio" name="t" checked={type === 'account'} onChange={() => setType('account')} style={{ marginTop: 3 }} />
              <span><b>Supprimer mon compte</b><br /><span style={{ color: '#9a90b0', fontSize: 12 }}>Compte, abonnement, profils et toutes les données seront supprimés définitivement.</span></span>
            </label>
            <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 18, cursor: 'pointer', fontSize: 14 }}>
              <input data-testid="deletion-type-data" type="radio" name="t" checked={type === 'data'} onChange={() => setType('data')} style={{ marginTop: 3 }} />
              <span><b>Supprimer uniquement mes données</b><br /><span style={{ color: '#9a90b0', fontSize: 12 }}>Historique de visionnage, avis et données personnelles supprimés, compte conservé.</span></span>
            </label>
            <label style={{ display: 'block', fontSize: 13, color: '#d6d0e0', marginBottom: 6 }}>Message (optionnel)</label>
            <textarea
              data-testid="deletion-message-input"
              value={message} onChange={(e) => setMessage(e.target.value)} rows={3}
              style={{ width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.15)', background: '#11041F', color: '#fff', fontSize: 14, marginBottom: 18, resize: 'vertical' }}
            />
            {error && <p style={{ color: '#ff7a6b', fontSize: 13 }}>{error}</p>}
            <button
              data-testid="deletion-submit-button"
              type="submit" disabled={loading}
              style={{ width: '100%', padding: '13px', borderRadius: 999, border: 'none', background: '#E9641A', color: '#fff', fontSize: 15, fontWeight: 'bold', cursor: 'pointer', opacity: loading ? 0.6 : 1 }}
            >
              {loading ? 'Envoi…' : 'Envoyer ma demande'}
            </button>
          </form>
        )}

        <p style={{ color: '#7a7290', fontSize: 12, marginTop: 24 }}>
          Vous pouvez également adresser votre demande par e-mail à{' '}
          <a href="mailto:contact@mayaplus.fr" style={{ color: '#E9641A' }}>contact@mayaplus.fr</a>.{' '}
          Politique de confidentialité : <a href="/confidentialite" style={{ color: '#E9641A' }}>mayaplus.fr/confidentialite</a>
        </p>
      </div>
    </div>
  );
}
